"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarrierHubIdLookup = void 0;
const stringEnum_1 = require("./stringEnum");
exports.CarrierHubIdLookup = (0, stringEnum_1.stringEnum)([
    "ATL",
    "BEN",
    "BWI",
    "CLT",
    "CVG",
    "DFW",
    "EWR",
    "FAT",
    "LAS",
    "LAX",
    "LCK",
    "MCO",
    "ORD",
    "RDU",
    "RNO",
    "SFO",
]);
//# sourceMappingURL=CarrierHub.js.map